<template>
  <b-sidebar
    v-if="isOpenLocal"
    v-model="isOpenLocal"
    id="sidebar-right-bdr2026-dict"
    :title="editedItemLocal.id ? `Редактирование #${editedItemLocal.id}` : 'Добавление статьи'"
    right
    backdrop
    shadow
    width="45em"
    backdrop-variant="dark"
    no-close-on-backdrop
  >
    <div class="d-block">
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-name-2026">Название</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            v-model="editedItemLocal.name"
            id="input-name-2026"
            size="sm"
          />
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;" v-if="!editedItemLocal.id">
        <b-col sm="3">
          <label for="input-unit-2026">Юнит</label>
        </b-col>
        <b-col sm="9">
          <b-form-select
            v-model="editedItemLocal.unit"
            :options="unitOptions"
            size="sm"
            id="input-unit-2026"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-parent-2026">Родитель</label>
        </b-col>
        <b-col sm="9">
          <b-form-select
            v-model="editedItemLocal.parent_id"
            :options="parentOptions"
            size="sm"
            id="input-parent-2026"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="isRootGroup" class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label>Расходная группа</label>
        </b-col>
        <b-col sm="9">
          <b-form-checkbox v-model="editedItemLocal.is_expense" switch>
            Итоги группы вычитаются из чистой прибыли (расходы)
          </b-form-checkbox>
        </b-col>
      </b-row>
      <div class="d-flex mt-2 mb-2">
        <b-button
          size="md"
          class="ml-auto btn btn-secondary"
          @click="closeSidebar()"
          :disabled="loading"
        >
          Отмена
        </b-button>
        <b-button
          size="md"
          class="ml-2 btn btn-primary"
          @click="saveElement()"
        >
          Сохранить <b-icon v-if="loading" icon="arrow-repeat" scale="1.2" :animation="loading ? 'spin' : ''"></b-icon>
        </b-button>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { API_BDR2026_DICTIONARY } from '@/constants';

const initialItem = () => ({
  name: '',
  parent_id: 0,
  unit: 'B2B',
  is_expense: false
});

export default {
  name: 'Bdr2026DictionarySidebar',
  props: {
    isOpen: { type: Boolean, required: true },
    editedItem: {
      type: Object,
      default: () => ({ name: '', parent_id: 0, unit: 'B2B', is_expense: false })
    },
    parentOptions: {
      type: Array,
      default: () => []
    },
    currentUnit: {
      type: String,
      default: 'B2B'
    }
  },
  data() {
    return {
      loading: false,
      unitOptions: [
        { value: 'B2B', text: 'B2B' },
        { value: 'B2C', text: 'B2C' },
        { value: 'БСЗ', text: 'БСЗ' }
      ]
    };
  },
  computed: {
    isOpenLocal: {
      get() { return this.isOpen; },
      set(value) { this.$emit('update:isOpen', value); }
    },
    editedItemLocal: {
      get() { return this.editedItem; },
      set() {}
    },
    isRootGroup() {
      const pid = this.editedItemLocal.parent_id;
      return pid === 0 || pid === '0' || pid === null;
    }
  },
  methods: {
    closeSidebar() {
      this.isOpenLocal = false;
    },
    saveElement() {
      this.loading = true;
      const payload = {
        name: this.editedItemLocal.name,
        parent_id: this.editedItemLocal.parent_id || 0
      };
      if (!this.editedItemLocal.id && this.editedItemLocal.unit) {
        payload.unit = this.editedItemLocal.unit;
      }
      if (this.isRootGroup) {
        payload.is_expense = !!this.editedItemLocal.is_expense;
      }
      if (this.editedItemLocal.id) {
        axios.put(`${API_BDR2026_DICTIONARY}/${this.editedItemLocal.id}`, payload)
          .then(() => {
            this.$emit('updateItem');
            this.loading = false;
            this.closeSidebar();
          })
          .catch(() => { this.loading = false; });
      } else {
        axios.post(API_BDR2026_DICTIONARY, payload)
          .then(() => {
            this.$emit('updateItem');
            this.loading = false;
            this.closeSidebar();
          })
          .catch(() => { this.loading = false; });
      }
    }
  }
};
</script>
